import { Dialog } from 'quasar'
import { InvoiceClient } from 'src/api/Invoices'
import { createErrorFromResponse } from 'src/utils/error'
import i18n from 'src/i18n/i18n'
import store from 'src/store'

export default invoiceId => {
  const client = new InvoiceClient()

  return client
    .include('payments')
    .get(invoiceId)
    .then(invoice => {
      const payments = invoice.data.data[0].payments.data

      return Dialog.create({
        title: i18n.t('reopen_invoice_title'),
        message: i18n.t('reopen_invoice_body'),
        ok: i18n.t('delete'),
        cancel: i18n.t('cancel')
      })
        .then(() => {
          return store.dispatch('deleteInvoicePayments', { invoiceId, payments: payments.map(payment => payment.id) })
        })
        .catch(() => {})
    })
    .catch(createErrorFromResponse)
}
